// extracted by mini-css-extract-plugin
module.exports = {"starter_packs_page":"StarterPacks_starter_packs_page__3Wef1","loading_screen":"StarterPacks_loading_screen__19KNb","loading_text":"StarterPacks_loading_text__xiQJm"};